module.exports = __webpack_public_path__ + "static/img/lxwm.074e723.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ch/lxwm.jpg
// module id = 2vWI
// module chunks = 1